module.exports = __webpack_public_path__ + "static/media/J.4aee7ea5.jpg";